import { ChangeEvent, CSSProperties, ForwardedRef, forwardRef, ReactNode, useState } from "react";
import { FilePathObject } from './index';


interface BaseProps {
    accept?: string,
    multiple?: boolean,
    onChanged?: (ev: ChangeEvent<HTMLInputElement>) => void,
    setFilePathMap?: (pathArr: FilePathObject[]) => void,
    disabled?: boolean,

    style?: CSSProperties,
    labelId?: string;
}

type FileEventTarget = EventTarget & { files: FileList }

const FileInputBase = forwardRef(function InputBase({
    disabled, multiple, accept, setFilePathMap = () => { },
    onChanged = (ev?: any) => { }, style, labelId = '', ...props
}: BaseProps, ref: ForwardedRef<HTMLInputElement>) {
    const [isLoading, setIsLoading] = useState(false);

    function handleFileChange(ev: ChangeEvent<HTMLInputElement>) {
        try {
            // @ts-ignore
            const el: FileEventTarget = ev.target;
            const fileArr = el?.files ? Array.from(el.files) : [];
            const pathMap: FilePathObject[] = [];

            fileArr.forEach(item => {
                const path = URL.createObjectURL(item);
                pathMap.push({
                    path: path,
                    mimeType: item.type,
                    size: item.size,
                    lastModified: item.lastModified,
                });
            })

            setFilePathMap(pathMap);
            onChanged(ev);
        } catch (e) {
            throw e;
        }
    }

    return (
        <input ref={ref} disabled={disabled} type="file" multiple={multiple} accept={accept} onChange={(ev: ChangeEvent<HTMLInputElement>) => {
            try {
                handleFileChange(ev);
            } catch (e) {
                console.error(e);
            }
        }} style={style} id={!!labelId ? labelId : undefined} />
    )
})

export {
    FileInputBase,
    type BaseProps as FileInputBaseProps,
    type FilePathObject,
}

export default FileInputBase;